module.exports = __webpack_public_path__ + "static/img/heighTec.1749a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/heighTec.jpg
// module id = X6pd
// module chunks = 21